import { BUAN_FUND_OFFICIAL_ADDRESS } from './encrypted-eas-kyc'

export const normalizeAddress = (address?: string | null): string | null => {
  if (!address || typeof address !== 'string') return null
  const normalized = address.trim().toLowerCase()
  const withPrefix = /^0x[a-f0-9]{40}$/
  const withoutPrefix = /^[a-f0-9]{40}$/

  if (withPrefix.test(normalized)) {
    return normalized
  }

  if (withoutPrefix.test(normalized)) {
    return `0x${normalized}`
  }

  return null
}

export const isBuanFundOfficialAddress = (address?: string | null): boolean => {
  const normalized = normalizeAddress(address)
  return normalized === BUAN_FUND_OFFICIAL_ADDRESS.toLowerCase()
}

export const isAuthorizedAdminAddress = (
  address?: string | null,
  staffAddresses: string[] = []
): boolean => {
  if (isBuanFundOfficialAddress(address)) return true
  const normalized = normalizeAddress(address)
  if (!normalized || staffAddresses.length === 0) return false
  return staffAddresses.some(item => normalizeAddress(item) === normalized)
}
